import {defineCustomElement} from 'extensions/ui-utils';
import stylesheet from './x-room.scss?as=stylesheet';
import {html, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';

export class Room extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			editMode: {
				state: true,
				type: Boolean
			},
			index: {
				type: Number
			},
			name: {
				type: String
			}
		};
	}

	constructor () {
		super();

		this.editMode = false;
		this.index = 0;
		this.name = '';
	}

	async toggleEditMode () {
		this.editMode = !this.editMode;

		if (this.editMode) {
			await this.updateComplete;
			this.renderRoot?.querySelector?.('#edit-input')?.select();
		}
	}

	handleChange (e) {
		this.dispatchEvent(new CustomEvent('change', {
			bubbles: true,
			detail: {
				index: this.index,
				name: e.target.value
			}
		}));
	}

	handleKeyup (e) {
		switch (e.key) {
			case 'Escape':
				this.toggleEditMode();
				break;
			default:
				break;
		}
	}

	renderEditMode () {
		return html`
			<button class="empty-button close-button icon-button" @click="${this.toggleEditMode}"></button>
			<div class="name">Rename Room</div>
			<div class="content">
				<form class="edit-group" @submit="${this.toggleEditMode}">
					<input required placeholder="Room Name" class="edit-input" id="edit-input" .value="${this.name}" type="text" @change="${this.handleChange}" @keyup="${this.handleKeyup}" />
					<button class="empty-button edit-submit-button icon-button"></button>
				</form>
			</div>
		`;
	}

	renderSelectionMode () {
		return html`
			<button class="empty-button name" @click="${this.toggleEditMode}">
				${this.name}
				<div class="edit-button icon-button" aria-label="Edit"></div>
			</button>
			<div class="content">
				<slot></slot>
			</div>
		`;
	}

	render () {
		const classes = {
			container: true,
			'edit-mode': this.editMode
		};

		return html`
			<div class="${classMap(classes)}">
				${this.editMode ? this.renderEditMode() : this.renderSelectionMode()}
			</div>
		`;
	}
};

defineCustomElement('x-room', Room);
